import { render, staticRenderFns } from "./GroupDetailForm.vue?vue&type=template&id=d60a367c&"
import script from "./GroupDetailForm.vue?vue&type=script&lang=js&"
export * from "./GroupDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports